import NiceModal from "@ebay/nice-modal-react";
import {observer} from "mobx-react";
import {callWithCatch, pp} from "../utils";
import DataTable from "./DataTable";
import {Form, Input, message, Modal} from "antd";
import {NiceModalForm} from "./Modals";
import React from "react";
import Tourney from "../apps/tourney/Tourney";
import _ from "lodash";

let ratingDisplay = r => (r && r > 0) ? String(r) : "NR";

export const EditPlayerDupr = NiceModal.create(observer(({ pl, load }) => {
  let onSave = async params => {
    await callWithCatch({
      url: `/players/${pl.id}`,
      method: 'put',
      params,
      onSuccess: data => {
        message.success("Saved!");

        load(data.player);
        NiceModal.remove(EditPlayerDupr);
      }
    })
  }

  let doublesR = _.find(pl.rating, { source: 'dupr', type: 'doubles' })?.rating;
  let singlesR = _.find(pl.rating, { source: 'dupr', type: 'singles' })?.rating;

  let initial = {
    wpr: pl.wpr || "NR",
    dupr_xid: pl.dupr_xid,
    dupr_doubles: ratingDisplay(doublesR),
    dupr_singles: ratingDisplay(singlesR),
  };

  let ratingRules = [{required: true, pattern: /^NR$|^0$|^[02345]\.\d{1,3}$/, message: "NR, 0 or 2.0-5.999"}];

  return <NiceModalForm onSave={onSave} title="Edit" okText="Save"
                        zIndex={1005}
                        initialValues={initial}
                        width={300}
  >
    <Form.Item label="Name">
      <Input value={pl.name} disabled />
    </Form.Item>
    <Form.Item name="dupr_xid" label="DUPR ID" rules={[{required: true, pattern: /^[A-Z0-9]+$/, message: "All uppercase/numbers e.g. 3XAVE4"}]}>
      <Input />
    </Form.Item>
    {(Tourney.milp || Tourney.joola) &&
      <Form.Item name="wpr" label="DUPR Rating"  rules={ratingRules}>
        <Input />
      </Form.Item>}
    {Tourney.njp && <>
      <Form.Item name="dupr_doubles" label="Doubles Rating" rules={ratingRules}>
        <Input />
      </Form.Item>
      <Form.Item name="dupr_singles" label="Singles Rating" rules={ratingRules}>
        <Input />
      </Form.Item>
    </>}
  </NiceModalForm>
}));


const SetDupr = NiceModal.create(observer(({ pl, text, onOk }) => {
  let onSave = async params => {
    await callWithCatch({
      url: `/players/${pl.id}/dupr`,
      method: 'post',
      params: {check: true, params},
      onSuccess: data => {
        let content = <DataTable data={[
          ["DUPR ID:", data.dupr_xid],
          ["DUPR Profile:", data.name],
          ["DUPR Rating:", data.rating],
        ]} />

        NiceModal.remove(SetDupr);
        Modal.success({
          okText,
          title: "DUPR connected", content, zIndex: 2000, onOk: async () => {
            await callWithCatch({
              url: `/players/${pl.id}/dupr`,
              method: 'post',
              params: {check: true, params},
              onSuccess: data => {
                onOk(data)
              }});
          }
        });
      }
    })
  }

  return <NiceModalForm onSave={onSave} title={text} okText={"Connect DUPR"}
                        width={300}
  >
    <Form.Item name="dupr_xid" label="DUPR ID">
      <Input autoFocus style={{width: "120px"}} placeholder="e.g. 3XAVE4"/>
    </Form.Item>
  </NiceModalForm>
}));
